import React, { useState, useEffect, createContext } from "react";
import { useHistory, useLocation } from "react-router-dom";

const TicketsContext = createContext();

const TicketsContextProvider = ({ children }) => {
	const [currentTicket, setCurrentTicket] = useState({ id: null, code: null });
	const [tabOpen, setTabOpen] = useState("open");
	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		// Só fazer push se não estivermos já na rota do ticket
		// e se currentTicket.id não for null
		if (currentTicket.id !== null && currentTicket.uuid && !location.pathname.includes(`/tickets/${currentTicket.uuid}`)) {
			history.push(`/tickets/${currentTicket.uuid}`);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentTicket])

	return (
		<TicketsContext.Provider
			value={{ currentTicket, setCurrentTicket, tabOpen, setTabOpen }}
		>
			{children}
		</TicketsContext.Provider>
	);
};

export { TicketsContext, TicketsContextProvider };
